/* @flow */

import * as types from 'src/shared/domain/event/action/eventActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

import {
  topicOneOnOneKind,
  topicGroupKind,
  topicFishbowlKind,
} from '@braindate/domain/lib/topic/setting';

import type { TopicKind } from '@braindate/domain/lib/topic/type';

/*
 |------------------------------------------------------------------------------
 | Initial state
 |------------------------------------------------------------------------------
 */

const initialStateKind: {
  isFetching: boolean,
} = {
  isFetching: false,
};

export const eventTimeSlotsSuggestionsInitialState: {
  [key: TopicKind]: typeof initialStateKind,
} = {
  [topicOneOnOneKind]: initialStateKind,
  [topicGroupKind]: initialStateKind,
  [topicFishbowlKind]: initialStateKind,
};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const handleRequest = (
  state: typeof eventTimeSlotsSuggestionsInitialState,
  action: {
    topicKind: TopicKind,
  },
) => {
  const { topicKind } = action;

  return {
    ...state,
    // $FlowIssue
    [topicKind]: {
      ...state[topicKind],
      isFetching: true,
    },
  };
};

const handleSuccess = (
  state: Object,
  action: {
    topicKind: TopicKind,
  },
) => {
  const { topicKind } = action;

  return {
    ...state,
    // $FlowIssue
    [topicKind]: {
      ...state[topicKind],
      isFetching: false,
    },
  };
};

const handleFailure = (
  state: Object,
  action: {
    topicKind: TopicKind,
  },
) => {
  const { topicKind } = action;

  return {
    ...state,
    // $FlowIssue
    [topicKind]: {
      ...state[topicKind],
      isFetching: false,
    },
  };
};

export default createReducer(eventTimeSlotsSuggestionsInitialState, {
  [types.FETCH_TIME_SLOTS_SUGGESTIONS_REQUEST]: handleRequest,
  [types.FETCH_TIME_SLOTS_SUGGESTIONS_SUCCESS]: handleSuccess,
  [types.FETCH_TIME_SLOTS_SUGGESTIONS_FAILURE]: handleFailure,
});
